import { createContext, useContext, useEffect, useState } from "react";

const CartContext = createContext(null);

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem("ess_cart") || "[]");
    } catch {
      return [];
    }
  });
  const [open, setOpen] = useState(false);

  useEffect(() => {
    localStorage.setItem("ess_cart", JSON.stringify(items));
  }, [items]);

  const add = (product) => {
    setItems((list) => {
      const found = list.find((i) => i.id === product.id);
      if (found) {
        return list.map((i) => (i.id === product.id ? { ...i, qty: Math.min(i.qty + 1, 20) } : i));
      }
      return [
        ...list,
        { id: product.id, name: product.name, brand: product.brand, price: product.price, image: product.image_url, qty: 1 },
      ];
    });
    setOpen(true);
  };

  const setQty = (id, qty) =>
    setItems((list) =>
      qty <= 0 ? list.filter((i) => i.id !== id) : list.map((i) => (i.id === id ? { ...i, qty: Math.min(qty, 20) } : i))
    );
  const remove = (id) => setItems((list) => list.filter((i) => i.id !== id));
  const clear = () => setItems([]);
  const count = items.reduce((s, i) => s + i.qty, 0);
  const subtotal = items.reduce((s, i) => s + i.price * i.qty, 0);

  return (
    <CartContext.Provider value={{ items, open, setOpen, add, setQty, remove, clear, count, subtotal }}>
      {children}
    </CartContext.Provider>
  );
}

export function useCart() {
  return useContext(CartContext);
}
